// extracted by mini-css-extract-plugin
export default {"wrapper":"UcmEIuMscT9yLl749Nb0","isSelected":"Ne1CakIkO4oyFoV9HwBF"};